import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MobileExperience from './MobileExperience';
import MobilePage from './MobilePage';
import MobileKnowledgeBasePage from './areas/knowledge-base/MobileKnowledgeBasePage';
import MobileResourceListPage from './areas/knowledge-base/MobileResourceListPage';
import MobileGlossaryPage from './areas/glossary/MobileGlossaryPage';
import MobileLeaderboardPage from './areas/leaderboard/MobileLeaderboardPage';
import MobileTeamLeaderLeaderboardPage from './areas/leaderboard/MobileTeamLeaderLeaderboardModal';
import MobileCultureHubDashboardPage from './areas/dashboard/MobileCultureHubDashboardPage';
import MobileGuidedSummaryPage from './MobileGuidedSummaryPage';
import MobileInterventionsTab from './areas/interventions/MobileInterventionsTab';
import MobilePillarPage from './areas/interventions/MobilePillarDialog';
import MobileFocusAreasTab from './areas/interventions/MobileFocusAreasTab';
import MobileFocusPlanRecommendations from './areas/interventions/MobileFocusPlanRecommendations';
import MobileFocusAreaDetail from './areas/interventions/MobileFocusAreaDetail';
import MobileFocusAreaActions from './areas/interventions/MobileFocusAreaActions';
import MobileResourceViewerPage from './areas/interventions/MobileResourceViewerPage';
import MobileResourceDetailsPage from './areas/knowledge-base/MobileResourceDetailsPage';
import MobileTeamLeaderExperience from './layouts/team-leader/MobileTeamLeaderExperience';
import MobileOrgAdminExperience from './layouts/org-admin/MobileOrgAdminExperience';
import MobileStaffExperience from './layouts/staff/MobileStaffExperience';

/**
 * Mobile router handles the mobile experience under /app/mobile.
 * This keeps mobile-specific pages separate from the main PortalRouter tree.
 */
const MobileRouter = () => (
  <Routes>
    <Route element={<MobilePage />}>
      <Route index element={<MobileExperience />} />
      <Route path="team-leader" element={<MobileTeamLeaderExperience />} />
      <Route path="org-admin" element={<MobileOrgAdminExperience />} />
      <Route path="staff" element={<MobileStaffExperience />} />
      <Route path="knowledge-base" element={<MobileKnowledgeBasePage />} />
      <Route path="knowledge-base/resources" element={<MobileResourceListPage />} />
      <Route path="knowledge-base/resource/:fileId" element={<MobileResourceViewerPage />} />
      <Route path="knowledge-base/resource/:fileId/details" element={<MobileResourceDetailsPage />} />
      <Route path="glossary" element={<MobileGlossaryPage />} />
      <Route path="leaderboard" element={<MobileLeaderboardPage />} />
      <Route path="leaderboard/details" element={<MobileTeamLeaderLeaderboardPage />} />
      <Route path="interventions" element={<MobileInterventionsTab />} />
      <Route path="interventions/:pillarKey" element={<MobilePillarPage />} />
      <Route path="focus-areas" element={<MobileFocusAreasTab />} />
      <Route path="focus-areas/recommendations" element={<MobileFocusPlanRecommendations />} />
      <Route path="focus-areas/recommendation/:templateId/:taskIndex" element={<MobileFocusAreaDetail />} />
      <Route path="focus-areas/recommendation/:templateId/:taskIndex/actions" element={<MobileFocusAreaActions />} />
      <Route path="focus-areas/resource/:fileId" element={<MobileResourceViewerPage />} />
      <Route path="guided-summary" element={<MobileGuidedSummaryPage />} />
      <Route path="culture-hub" element={<MobileCultureHubDashboardPage />} />
    </Route>
    <Route path="*" element={<Navigate to="" replace />} />
  </Routes>
);

export default MobileRouter;
